import { useEffect, useState } from 'react';

const MD_UP = '(min-width: 768px)';

/** Bootstrap `md` 以上か（表/カードの単一描画・二重 DOM 回避） */
export function useMdUp(): boolean {
  const [mdUp, setMdUp] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MD_UP).matches : true
  );

  useEffect(() => {
    const mq = window.matchMedia(MD_UP);
    const sync = () => setMdUp(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return mdUp;
}

/** Labo助 既存 import 用（実装は useMdUp） */
export const useLaboSukeMdUp = useMdUp;
